import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import BlocActualites from '@/components/ActualitesComponent'
import { DepensesCarteSearch } from '@/models/depensescarte.model'

export default {
  data () {
    return {
      depensesCarteSearch: new DepensesCarteSearch(),
      loading: false,
      listePeriodes: []
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    BlocActualites
  },
  methods: {
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    },
    getPeriodesToDisplay (periode) {
      let echeance = {}
      echeance.cardId = this.$store.state.user.actualSelectedCard.cardId
      echeance.periodeId = periode.periodeId
      echeance.debit = periode.debit
      echeance.credit = periode.credit
      echeance.porteur = this.getCivility() + ' ' + this.$store.state.user.user.firstName + ' ' + this.$store.state.user.user.lastName
      echeance.cardNumber = this.$store.state.user.actualSelectedCard.cardNumberEncrypted
      echeance.compte = this.$store.state.user.actualSelectedCard.compte

      this.$store.dispatch('porteur/selectEditedEcheance', echeance)
      this.$store.dispatch('porteur/selectEditedPeriod', periode)
      this.$router.push({ name: 'porteur/operationscarte' })
    },
    getCivility () {
      if (this.$store.state.user.user.civility === 'MONSIEUR') {
        return 'M.'
      }
      if (this.$store.state.user.user.civility === 'MADEMOISELLE') {
        return 'Melle'
      }
      if (this.$store.state.user.user.civility === 'MADAME') {
        return 'Mme'
      }
    },
    updateSelectedCard (theCardIndex) {
      this.getDepensesCartes(theCardIndex)
    },
    getDepensesCartes (theCardIndex) {
      this.depensesCarteSearch.possibleCardsToSee = []
      this.depensesCarteSearch.possibleCardsToSee.push(this.$store.state.user.user.possibleCardsToSee[theCardIndex])
      this.depensesCarteSearch.loggedUser = this.$store.state.user.user.login
      this.loading = true
      this.$store.dispatch('porteur/getDepensesCarte', this.depensesCarteSearch).then(
        response => {
          this.loading = false
          this.listePeriodes = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    }
  },
  mounted () {
    this.getDepensesCartes(0)
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Dépenses cartes'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
    this.$store.dispatch('porteur/selectEditedEcheance', null)
    this.$store.dispatch('porteur/selectEditedPeriod', null)
  }
}
